export const parseDate = (dateString: string): Date | undefined => {
  if (!dateString) return undefined;

  const [dayPart, monthPart, yearPart] = dateString.split(".");
  const dayPartRegex = /(0[1-9]|[12]\d|3[01])/;
  const monthPartRegex = /(0[1-9]|1[0-2])/;
  const yearPartRegex = /^[12][0-9]{3}$/;

  if (
    dayPartRegex.test(dayPart) &&
    monthPartRegex.test(monthPart) &&
    yearPartRegex.test(yearPart)
  ) {
    return new Date(
      Number.parseInt(yearPart, 10),
      // month is 0 based index
      Number.parseInt(monthPart, 10) - 1,
      Number.parseInt(dayPart, 10)
    );
  }

  return undefined;
};

export const parseDateRange = (
  dateRangeString: string
): [Date | undefined, Date | undefined] => {
  const [rangeStartString, rangeEndString] = dateRangeString.split("-");

  const rangeStart = parseDate(rangeStartString);
  const rangeEnd = parseDate(rangeEndString);

  return [rangeStart, rangeEnd];
};
